import React, { useState } from 'react';
import ProgressCircle from '../ProgressCircle';
import { useData } from '../../hooks/useData';
import { ChevronDown, ChevronRight, X } from 'lucide-react';
import { LoaderSpinner } from '../Layout/LoaderSpinner';
import { ellipseText, getFileIcon } from '../../utils/tools';
const FileUploadStatus = (props) => {

    const {fileUploadProgress, uploads, removeUpload, clearUploads} = useData();
    const [isOpen, setIsOpen] = useState(true);
    const handleChevronClick = () => {
        setIsOpen(!isOpen);
    };

    // Remove file and cancel upload
    const handleRemoveFile = (index) => {
        removeUpload(index);
    };

    // Close the entire upload status component
    const handleCloseAll = () => {
        clearUploads();
    };

    // Check if all uploads are complete
    const allUploadsComplete = uploads.length > 0 && uploads.every(file => file.progress >= 100);

    return (
        <div style={ uploads.length > 0 ? {display: 'flex'} : {display: 'none'}} className={`file-upload-status ${isOpen ? 'open' : ''}`}>
            <div onClick={handleChevronClick} className="file-upload-status-header">
                {/* <ProgressCircle percentage={75} size={16} strokeWidth={9} /> */}
                <div className="file-upload-status-header-content">
                    { uploads.length > 0 && fileUploadProgress < 100 ? (
                        <>
                            <LoaderSpinner absolute={false}/>
                            <div style={{marginLeft:18}} className="count-circle">{uploads.length}</div>
                            <p style={{marginLeft:7}}>files uploading</p>
                        </>
                    ):(
                        <>
                            <div style={{marginLeft:-4}} className="count-circle">{uploads.length}</div>
                            <p style={{marginLeft:7}}>files uploaded</p>
                        </>
                    )}
                    
                    <div 
                    
                    className="file-upload-status-chevron"
                    >
                    {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    </div>
                </div>
                <div className="file-upload-progress-bar">
                    <div style={{width: `${fileUploadProgress}%`}} className="file-upload-progress-bar-fill"></div>
                </div>
                
            </div>
            {allUploadsComplete && (
                <div
                    style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        background: 'var(--bg-panel)',
                        border: '1px solid var(--border-color)',
                        color: 'var(--text-secondary)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.color = 'var(--text-primary)';
                        e.target.style.background = 'var(--bg-hover)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.color = 'var(--text-secondary)';
                        e.target.style.background = 'var(--bg-panel)';
                    }}
                    onClick={handleCloseAll}
                >
                    <X size={12} />
                </div>
            )}
            {isOpen && (
                <div className="file-upload-status-content">
                    {uploads.map((file, i) => (
                        <div key={i} className="file-upload-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="file-upload-item-content" >
                                {(() => {
                                    const { icon } = getFileIcon(file.ext, 18);
                                    return (
                                        <>
                                            {icon}
                                            <p>{ellipseText(file.name, 22, true)}</p>
                                        </>
                                    );
                                })()}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <ProgressCircle percentage={file.progress} size={16} strokeWidth={9} />
                                {file.progress < 101 && (
                                    <button
                                        onClick={() => handleRemoveFile(i)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            padding: '2px',
                                            marginLeft: 4,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '3px',
                                            color: 'var(--text-secondary)',
                                            transition: 'all 0.2s ease',
                                            minWidth: '20px',
                                            minHeight: '20px',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.color = 'var(--text-primary)';
                                            e.target.style.background = 'var(--bg-hover)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.color = 'var(--text-secondary)';
                                            e.target.style.background = 'none';
                                        }}
                                        aria-label="Remove file"
                                    >
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FileUploadStatus; 



   
